/**
 * HAWK MATERIAL MANAGER vFinal (Data Sync Fix)
 * - Onaylama sırasında veri kaybını önler.
 * - window.siparis_data ve window.orderData'yı EŞİTLER.
 */

class HawkMaterialManager {
    constructor() {
        this.globals = window; 
        this.viewer = document.getElementById("hawkgamingchair");
        this.originalTextures = {}; // Önbellek deposu

        this.textureCache = {};
        // Doku Yolları
        this.textures = {
            deri: { normal: '/static/textures/deri/deri_normal.jpg', roughness: '/static/textures/deri/deri_roughness3.jpg' },
            kumas: { normal: '/static/textures/kumas/kumas_normal2.webp', roughness: '/static/textures/kumas/kumas_roughness.jpg' },
            kadife: { normal: '/static/textures/kadife/kadife_normal.jpg', roughness: '/static/textures/kadife/kadife_roughness.webp' }
        };
    }

    // -------------------------------------------------------
    // 1. ONAY MANTIĞI (VERİ GARANTİLİ)
    // -------------------------------------------------------
    // -------------------------------------------------------
    // 1. ONAY MANTIĞI (FİYAT SIFIRLANMA HATASI DÜZELTİLDİ)
    // -------------------------------------------------------

    // HawkMaterialManager.js -> captureInitialState GÜNCELLEMESİ

    // HawkMaterialManager.js -> captureInitialState

    captureInitialState() {
        this.originalTextures = {}; // Sıfırla
        
        const category = (this.globals.cinsbutton && this.globals.cinsbutton[0]) ? this.globals.cinsbutton[0] : "future";
        const capCat = category.charAt(0).toUpperCase() + category.slice(1);
        const productTitle = (this.globals.tasarimismiKontrol && this.globals.tasarimismiKontrol[0]) ? this.globals.tasarimismiKontrol[0] : "";

        if (!this.viewer.model) return;
        
        const mats = this.viewer.model.materials;
        const map = this.getMaterialMap(capCat, mats, productTitle);

        // Tüm olası bölgeleri tara ve cache'e at
        const zones = ["Ön Logo", "Arka Logo", "Bel Logo", "Yastık Logo", "Nickname"];

        zones.forEach(type => {
            const mat = map[type];
            if (mat) {
                this.updatePatternCache(type, mat);
            }
        });
    }

    restoreInitialState() {
        if (Object.keys(this.originalTextures).length === 0) {
            return;
        }

        for (const [type, data] of Object.entries(this.originalTextures)) {
            if (data.material) {
                // Orijinal texture'ı geri ata (null ise dokuyu kaldırır)
                if (data.material.pbrMetallicRoughness.baseColorTexture) {
                    data.material.pbrMetallicRoughness.baseColorTexture.setTexture(data.texture);
                } else if (data.texture) {
                    // Slot yoksa ama texture varsa (nadir durum)
                    data.material.pbrMetallicRoughness.baseColorTexture.setTexture(data.texture);
                }
            }
        }
        
        // Nickname için de Yastık Logo cache'ini kullan (Aynı materyal)
        this.updateGlobalState("Nickname", false);
        
    }

    // Helper: Tip isminden materyali bul
    resolveMaterial(type, category, map) {
        if (type === "Ön Logo") {
            if(category.includes("Fab")) return map["FAB ön-logo"];
            if(category.includes("Fame")) return map["FAME on-logo"];
            if(category.includes("Pro")) return map["PRO ON-LOGO"];
            return map["FUTURE ustlogo"];
        }
        if (type === "Arka Logo") {
            if(category.includes("Fab")) return map["FAB arka"];
            if(category.includes("Fame")) return map["FAME famegold"];
            if(category.includes("Pro")) return map["PRO ARKA-LOGO"];
            return map["FUTURE arkalogo"];
        }
        if (type === "Bel Logo") {
            if(category.includes("Fab")) return map["FAB bel-logo"];
            if(category.includes("Fame")) return map["FAME bel-logo"];
            if(category.includes("Pro")) return map["PRO BEL LOGO"];
            return map["FUTURE bellogo"];
        }
        if (type === "Yastık Logo" || type === "Nickname") {
            if(category.includes("Fab")) return map["FAB fab-koltuk-logo"];
            if(category.includes("Fame")) return map["FAME nickname"];
            if(category.includes("Pro")) return map["PRO BAS YASTIK LOGO"];
            return map["FUTURE yastiklogo"];
        }
        return null;
    }

    async confirmSelection(type) {

        // 1. INPUT DEĞERLERİNİ HEMEN YAKALA
        const nickInput = document.getElementById("nickname");
        const colorInput = document.getElementById("nicknameColor");
        const currentNickText = nickInput ? nickInput.value : "";
        const currentColor = colorInput ? colorInput.value : "#ffffff";

        // 2. ÇAKIŞMA TEMİZLİĞİ
        if (type === "Nickname") {
            this.globals.yastiklogoyuklendi = false;
            this.globals.resultyastiklogo = [];
            if(window.siparis_data) window.siparis_data.yastik_logo = ["yok"];
            if(typeof guncelleFiyat === 'function') guncelleFiyat("Yastık Logo"); 
        } 
        else if (type === "Yastık Logo") {
            this.globals.nicknameyuklendi = false;
            if(window.siparis_data) window.siparis_data.nickname = ["yok"];
            if(typeof guncelleFiyat === 'function') guncelleFiyat("Nickname"); 
        }

        // 3. GLOBAL BAYRAKLARI GÜNCELLE
        this.updateGlobalState(type, true);

        // 4. VERİ TABANLARINI GÜNCELLE
        if (window.siparis_data) {
            if (type === "Nickname") {
                window.siparis_data.nickname = [currentNickText];
                window.siparis_data.nicknamecolor = [currentColor];
            } else if (type === "Ön Logo") window.siparis_data.on_logo = ["var"];
            else if (type === "Arka Logo") window.siparis_data.arka_logo = ["var"];
            else if (type === "Bel Logo") window.siparis_data.bel_logo = ["var"];
            else if (type === "Yastık Logo") window.siparis_data.yastik_logo = ["var"];
        }

        if (window.orderData && window.orderData.Features) {
            if (type === "Nickname") {
                window.orderData.Features.Nickname.Text = currentNickText;
                window.orderData.Features.Nickname.Color = currentColor;
            } else if (type === "Ön Logo") window.orderData.Features.Patterns.Front = "data:image/png;base64,iVBORw0KGgoAAAA";
            else if (type === "Arka Logo") window.orderData.Features.Patterns.Back = "data:image/png;base64,iVBORw0KGgoAAAA";
            else if (type === "Bel Logo") window.orderData.Features.Patterns.Waist = "data:image/png;base64,iVBORw0KGgoAAAA";
            else if (type === "Yastık Logo") window.orderData.Features.Nickname.Text = "data:image/png;base64,iVBORw0KGgoAAAA";
        }

        // 5. YENİ FİYATI UI'A YAZ
        // Manuel güncelleme (Yastık/Nick için) veya Standart
        if (type === "Yastık Logo" || type === "Nickname") {
            const priceEl = document.getElementById('isimfiyati');
            if (priceEl) {
                const title = type === "Yastık Logo" ? "Üst Yastık Logo" : "Nickname";
                const priceVal = window.customfiyatlar ? window.customfiyatlar.find(x => x.Title === title)?.Description : "0";
                
                const pTag = priceEl.querySelector('p');
                const spanTag = priceEl.querySelector('span');
                
                if(pTag) pTag.innerText = type === "Yastık Logo" ? "Yastık Logo :" : "İsim Yazdırma :";
                if(spanTag) spanTag.innerText = priceVal + " ₺";
                
                priceEl.classList.remove('active');
                priceEl.classList.add('black');
                priceEl.style.display = "flex";
            }
        } else {
            if (typeof guncelleCustomFiyat === 'function') await guncelleCustomFiyat(type);
        }

        // 6. KRİTİK HAMLE: ANA FİYATLARI TEKRAR YAZDIR (Refresh)
        // Onaylama anında ana fiyatların silinmediğinden emin oluyoruz.
        if (typeof guncelleFiyat === 'function') {
            guncelleFiyat('koltuk'); // Koltuk fiyatını garantile
            guncelleFiyat('desen');  // Desen fiyatını garantile
        }

        // 7. TOPLAM FİYATI ŞİMDİ HESAPLA
        if (typeof updateTotalPrice === 'function') {
            setTimeout(() => {
                updateTotalPrice();
            }, 50);
        }

        // 8. ARAYÜZÜ KAPAT (YUMUŞAK RESET)
        if (window.hawkUI) window.hawkUI.resetUI(false);
        if (typeof checksiparis === 'function') checksiparis();
    }

    // -------------------------------------------------------
    // 2. RED MANTIĞI (TEMİZLİK)
    // -------------------------------------------------------
    // -------------------------------------------------------
    // 2. RED MANTIĞI (FİYAT SIFIRLANMA HATASI DÜZELTİLDİ)
    // -------------------------------------------------------
    async rejectSelection(type) {
        
        // UI Fiyat Güncelleme
        let targetId = "";
        if (type === "Ön Logo") targetId = "onfiyati";
        else if (type === "Arka Logo") targetId = "arkafiyati";
        else if (type === "Bel Logo") targetId = "belfiyati";
        else if (type === "Nickname" || type === "Yastık Logo") targetId = "isimfiyati";

        if (targetId) {
            const priceEl = document.getElementById(targetId);
            if (priceEl) {
                // 1. Fiyatı 0 Yap
                const span = priceEl.querySelector('span');
                if (span) span.innerText = "0 ₺";
                
                // 2. Stilleri "Pasif" Hale Getir
                priceEl.classList.remove('black'); // Dolu olduğunu gösteren class'ı sil
                priceEl.classList.add('active');   // Varsayılan class'ı ekle

                // 3. DİV'İ GİZLEME! (Kritik Düzeltme Burası)
                // Eski kod: priceEl.style.display = "none"; -> BU SATIRI KALDIRDIK
                // Yeni kod: Görünür bırak veya CSS kontrolüne ver
                priceEl.style.display = ""; // Varsa inline 'display:none' stilini temizler, CSS'e döner.

                // 4. Sadece içindeki "X" butonunu gizle (İsteğe bağlı, mantıken boş olana tekrar x basılamaz)
                const removeBtn = priceEl.querySelector('.remove-button');
                if(removeBtn) removeBtn.style.display = 'none';
            }
        }

        this.updateGlobalState(type, false);
        
        if (typeof guncelleFiyat === 'function') { guncelleFiyat('koltuk'); guncelleFiyat('desen'); }
        if (typeof updateTotalPrice === 'function') setTimeout(() => updateTotalPrice(), 50);

        // Veri Temizle (Backend)
        const updateOrder = window.updateOrderJson || (window.checkoutManager ? window.checkoutManager.updateOrderData.bind(window.checkoutManager) : null);
        if (window.siparis_data) {
            if (type === "Nickname") { window.siparis_data.nickname = ["yok"]; window.siparis_data.nicknamecolor = ["#ffffff"]; }
            else if (type === "Ön Logo") window.siparis_data.on_logo = ["yok"];
            else if (type === "Arka Logo") window.siparis_data.arka_logo = ["yok"];
            else if (type === "Bel Logo") window.siparis_data.bel_logo = ["yok"];
            else if (type === "Yastık Logo") window.siparis_data.yastik_logo = ["yok"];
        }
        if (updateOrder) {
            if (type === "Nickname") { updateOrder("", "Features.Nickname.Text"); updateOrder("#ffffff", "Features.Nickname.Color"); }
            else if (type === "Ön Logo") updateOrder("", "Features.Patterns.Front");
            else if (type === "Arka Logo") updateOrder("", "Features.Patterns.Back");
            else if (type === "Bel Logo") updateOrder("", "Features.Patterns.Waist");
            else if (type === "Yastık Logo") updateOrder("", "Features.Nickname.Text");
        }

        // Doku Geri Yükle (Cache'den)
       
            await this.revertTexture(type);
        

        if (window.hawkUI) window.hawkUI.resetUI(false);
        if (typeof checksiparis === 'function') checksiparis();
    }

    updateGlobalState(type, isActive) {
        if (type === "Ön Logo") this.globals.onlogoyuklendi = isActive;
        else if (type === "Arka Logo") this.globals.arkalogoyuklendi = isActive;
        else if (type === "Bel Logo") this.globals.bellogoyuklendi = isActive;
        else if (type === "Yastık Logo") {
             this.globals.yastiklogoyuklendi = isActive;
             if(isActive) this.globals.nicknameyuklendi = false;
        }
        else if (type === "Nickname") {
            this.globals.nicknameyuklendi = isActive;
            if(isActive) this.globals.yastiklogoyuklendi = false;
        }
    }

   

    // -------------------------------------------------------
    // REVERT TEXTURE (MATERYAL BULMA FIX)
    // -------------------------------------------------------
    async revertTexture(type) {
        
        // 1. BAYRAKLARI KAPAT
        if (type === "Ön Logo") this.globals.onlogoyuklendi = false;
        else if (type === "Arka Logo") this.globals.arkalogoyuklendi = false;
        else if (type === "Bel Logo") this.globals.bellogoyuklendi = false;
        else if (type === "Nickname") {
            this.globals.nicknameyuklendi = false;
            if (this.globals.resultyastiklogo && this.globals.resultyastiklogo.length > 0) {
                this.globals.yastiklogoyuklendi = true;
            } else {
                this.globals.yastiklogoyuklendi = false;
            }
        }
        else if (type === "Yastık Logo") { this.globals.yastiklogoyuklendi = false; }

        // 2. ORTAM DEĞİŞKENLERİ
        const categoryRaw = this.globals.cinsbutton ? this.globals.cinsbutton[0] : "future";
        const category = categoryRaw.charAt(0).toUpperCase() + categoryRaw.slice(1);
        const productTitle = (this.globals.tasarimismiKontrol && this.globals.tasarimismiKontrol[0]) ? this.globals.tasarimismiKontrol[0] : "";
        const isOriginalPattern = productTitle.includes("Orijinal");
        const features = window.currentPatternFeatures || [];

        const mats = this.viewer.model.materials;
        const map = this.getMaterialMap(category, mats, productTitle);

        // ---------------------------------------------------------
        // 3. MATERYALİ BUL (KRİTİK EKSİK TAMAMLANDI)
        // ---------------------------------------------------------
        let targetMat = map[type]; // Önce "Ön Logo" diye ara

        if (!targetMat) {
            // Bulamazsa teknik isimlerle ara
            if (category === "Future") {
                if (type === "Ön Logo") targetMat = map["FUTURE ustlogo"];
                if (type === "Arka Logo") targetMat = map["FUTURE arkalogo"];
                if (type === "Bel Logo") targetMat = map["FUTURE bellogo"];
                if (type === "Yastık Logo" || type === "Nickname") targetMat = map["FUTURE yastiklogo"];
            }
            else if (category === "Pro") {
                if (type === "Ön Logo") targetMat = map["PRO ON-LOGO"];
                if (type === "Arka Logo") targetMat = map["PRO ARKA-LOGO"];
                if (type === "Bel Logo") targetMat = map["PRO BEL LOGO"];
                if (type === "Yastık Logo" || type === "Nickname") targetMat = map["PRO BAS YASTIK LOGO"];
            }
            else if (category === "Fab") {
                if (type === "Ön Logo") targetMat = map["FAB ön-logo"];
                if (type === "Arka Logo") targetMat = map["FAB arka"];
                if (type === "Bel Logo") targetMat = map["FAB bel-logo"];
                if (type === "Yastık Logo" || type === "Nickname") targetMat = map["FAB fab-koltuk-logo"];
            }
            else if (category === "Fame") {
                if (type === "Ön Logo") targetMat = map["FAME on-logo"] || map["FAME hawk-kanat"];
                if (type === "Arka Logo") targetMat = map["FAME arka-logo"] || map["FAME famegold"];
                if (type === "Bel Logo") targetMat = map["FAME bel-logo"];
                if (type === "Yastık Logo" || type === "Nickname") targetMat = map["FAME nickname"];
            }
            else if (category === "Aksesuar") {
                if (type.includes("Yastık") || type.includes("Nick")) targetMat = map["aksesuar ustyastik logo"] || map["Yastık Logo"];
                if (type.includes("Bel")) targetMat = map["aksesuar bel yastık logo"] || map["Bel Logo"];
            }
        }

        if (!targetMat) {
            console.warn(`❌ HATA: Restore için materyal bulunamadı! (${type})`);
        } else {
            console.log(`   ✅ Materyal Hedeflendi: ${targetMat.name}`);
        }

        // ---------------------------------------------------------
        // 4. GÖRSEL RESTORE (LINK BUL VE YÜKLE)
        // ---------------------------------------------------------
        
        // Helper: Link Bulucu
        const findTexturePath = (targetType) => {
            if (!features.length) return null;
            let searchKeys = [];

            if (targetType === "Ön Logo") searchKeys = ["ustlogo", "on-logo", "ön-logo", "hawk-kanat", "on_logo", "fame on-logo"];
            else if (targetType === "Arka Logo") { searchKeys = ["arkalogo", "arka-logo", "famegold", "arka_logo", "fame arka-logo"]; searchKeys.push("arka"); }
            else if (targetType === "Bel Logo") {
                if (category === "Aksesuar") {
                    // --- DÜZELTME BURADA ---
                    // Logo katmanı için sadece "logo" içeren parçayı döndür! 
                    // Kumaşı döndürme (Onu aşağıda 5. adımda halledeceğiz).
                    const f = features.find(feat => feat.TypeName.includes("aksesuar bel yastık logo"));
                    return f ? f.FilePath : null;
                }
                searchKeys = ["bellogo", "bel-logo", "bel_logo", "bel logo"];
            }
            else if (targetType === "Yastık Logo" || targetType === "Nickname") {
                if (category === "Aksesuar") {
                     const f = features.find(feat => feat.TypeName.includes("aksesuar ustyastik logo"));
                     return f ? f.FilePath : null;
                }
                searchKeys = ["yastiklogo", "yastık logo", "bas yastik logo", "ust-yastik", "fame nickname", "fab fab-koltuk-logo"];
            }

            const found = features.find(f => {
                const t = f.TypeName.toLowerCase();
                return searchKeys.some(key => t.includes(key));
            });
            return found ? found.FilePath : null;
        };
        
        // ÖNCELİK 1: CANLI DESEN LİNKİ (Sorunsuz geçiş için)
        // Cache yerine önce mevcut desenin linkini deniyoruz.
        const originalUrl = findTexturePath(type);
        let cacheKey = type; // ... Cache key mantığı ...
        if (targetMat) {
            if (originalUrl) {
                await this.applyTexture(targetMat, originalUrl);
            } 
            // ÖNCELİK 2: CACHE (Eğer link yoksa ama hafızada varsa)
            else if (this.originalTextures && this.originalTextures[cacheKey] && this.originalTextures[cacheKey].texture) {
                const data = this.originalTextures[cacheKey];
                targetMat.pbrMetallicRoughness.baseColorTexture.setTexture(data.texture);
                console.log(`   ✅ Cache'den Restore Edildi.`);
            }
            // ÖNCELİK 3: TEMİZLE (Hiçbir şey yoksa)
            else {

                if (category === "Aksesuar") {
                    console.log(`   🧹 Aksesuar Logo Temizlendi (Null)`);
                    targetMat.pbrMetallicRoughness.baseColorTexture.setTexture(null);
                }
                // Yastık istisnası (Orijinal Hawk Logosu)
                else if ((type === "Yastık Logo" || type === "Nickname") && this.globals.ustOriginalLink && category !== "Aksesuar") {
                     await this.applyTexture(targetMat, this.globals.ustOriginalLink);
                } else {
                     console.log(`   🧹 Temizleniyor (${type}): NULL`);
                     if(targetMat.pbrMetallicRoughness.baseColorTexture) targetMat.pbrMetallicRoughness.baseColorTexture.setTexture(null);
                }
            }
        }

        // 5. ARKA PLAN RESTORE (Future/Pro Bel Yastığı)
        if (type === "Bel Logo") {
            if (category === "Future") {
                const bgMat = map["FUTURE alt-yastik"] || map["aksesuar bel yastık"];
                if (bgMat) {
                    const waistBgFeature = features.find(f => f.TypeName.includes("alt-yastik") || (category==="Aksesuar" && f.TypeName.includes("bel yastık") && !f.TypeName.includes("logo")));
                    if (waistBgFeature) await this.applyTexture(bgMat, waistBgFeature.FilePath);
                    else if (this.globals.belOriginalLink) await this.applyTexture(bgMat, this.globals.belOriginalLink);
                }
            }
            else if (category === "Aksesuar") {
                // Aksesuar kumaş materyali
                const bgMat = map["aksesuar bel yastık"]; 
                if (bgMat) {
                    // Özelliklerden "logo" OLMAYAN parçayı (Kumaşı) bul
                    const fabricFeat = features.find(f => f.TypeName.includes("aksesuar bel yastık") && !f.TypeName.includes("logo"));
                    
                    if (fabricFeat) {
                        console.log(`   🔄 Aksesuar Kumaş Restore: ${fabricFeat.FilePath}`);
                        await this.applyTexture(bgMat, fabricFeat.FilePath);
                    }
                }
            }
            else if (category === "Pro") {
                const bgMat = map["PRO YASTIK"];
                if (bgMat) {
                    const proBgFeature = features.find(f => f.TypeName === "PRO YASTIK");
                    if (proBgFeature) await this.applyTexture(bgMat, proBgFeature.FilePath);
                    else if (this.globals.proOriginalLink) await this.applyTexture(bgMat, this.globals.proOriginalLink);
                }
                const signMat = map["PRO BEL IMZA"];
                if(signMat) {
                    const signFeature = features.find(f => f.TypeName === "PRO BEL IMZA");
                    if(signFeature) await this.applyTexture(signMat, signFeature.FilePath);
                }
            }
        }

        // 6. UI GÜNCELLEME
        let priceKey = "";
        let targetDivId = "";
        if (type === "Ön Logo") { priceKey = "ön"; targetDivId = "onfiyati"; }
        else if (type === "Arka Logo") { priceKey = "arka"; targetDivId = "arkafiyati"; }
        else if (type === "Bel Logo") { priceKey = "bel"; targetDivId = "belfiyati"; }
        else if (type === "Yastık Logo" || type === "Nickname") {
             if (this.globals.yastiklogoyuklendi) priceKey = "üstyastık"; else priceKey = "nick";
             targetDivId = "isimfiyati";
        }

        if (typeof guncelleFiyat === 'function' && priceKey) guncelleFiyat(priceKey); 

        if(targetDivId) {
            const div = document.getElementById(targetDivId);
            if(div) {
                const removeBtn = div.querySelector('.remove-button');
                const keepOpen = (type === "Nickname" && this.globals.yastiklogoyuklendi);
                if (removeBtn && !keepOpen) removeBtn.style.display = 'none';
                
                div.classList.remove('black'); div.classList.add('active');
                if (keepOpen) { div.classList.add('black'); div.classList.remove('active'); }
                
                div.style.display = 'flex'; 
            }
        }

        // 7. DATA RESTORE (Backend ID)
        const updateOrder = window.updateOrderJson || (window.checkoutManager ? window.checkoutManager.updateOrderData.bind(window.checkoutManager) : null);
        
        if (updateOrder) {
            const findOriginalID = (partType) => {
                if (!features.length) return "";
                let searchKeys = [];
                
                if (partType === "Ön Logo") searchKeys = ["ustlogo", "on-logo", "ön-logo", "hawk-kanat", "on_logo", "fame on-logo"];
                else if (partType === "Arka Logo") { searchKeys = ["arkalogo", "arka-logo", "famegold", "arka_logo", "fame arka-logo"]; searchKeys.push("arka"); }
                else if (partType === "Bel Logo") {
                    if (category === "Aksesuar") {
                        const found = features.find(f => f.TypeName.includes("aksesuar bel yastık") && !f.TypeName.includes("logo"));
                        return found ? found.FeatureID : "";
                    }
                    searchKeys = ["bellogo", "bel-logo", "bel_logo", "bel logo"];
                }
                else if (partType === "Yastık Logo") searchKeys = ["yastiklogo", "yastık logo", "bas yastik logo", "ust-yastik", "aksesuar ustyastik logo"];
                
                const found = features.find(f => {
                    const t = f.TypeName.toLowerCase();
                    return searchKeys.some(key => t.includes(key));
                });
                return found ? found.FeatureID : ""; 
            };

            if (type === "Ön Logo") updateOrder(findOriginalID("Ön Logo") || "", "Features.Patterns.Front");
            else if (type === "Arka Logo") updateOrder(findOriginalID("Arka Logo") || "", "Features.Patterns.Back");
            else if (type === "Bel Logo") updateOrder(findOriginalID("Bel Logo") || "", "Features.Patterns.Waist");
            
            else if (type === "Yastık Logo" || type === "Nickname") {
                if (this.globals.yastiklogoyuklendi) {
                     updateOrder("base64", "Features.Nickname.Text");
                } else {
                     const accID = findOriginalID("Yastık Logo");
                     if (accID && category === "Aksesuar") updateOrder("", "Features.Nickname.Text");
                     else window.updateOrderJson("", "Features.Nickname.Text");
                     
                     if (window.orderData?.Features?.Nickname) window.orderData.Features.Nickname.Color = "#ffffff";
                }
            }
        }

        if (window.hawkUI) window.hawkUI.resetUI(false); 
        if (typeof updateTotalPrice === 'function') updateTotalPrice(); 
        if (typeof checksiparis === 'function') checksiparis();
        
        console.groupEnd();
    }
    async applyTexture(material, textureSource) {
        if (!material || !this.viewer) return;
        try {
            const texture = await this.viewer.createTexture(textureSource);
            if (material.pbrMetallicRoughness['baseColorTexture']) {
                material.pbrMetallicRoughness['baseColorTexture'].setTexture(texture);
            } else {
                material['baseColorTexture']?.setTexture(texture);
            }
            await this.applyRealismMaps(material);
        } catch (e) { }
    }

 

    async applyRealismMaps() {
        if (!this.viewer || !this.viewer.model) return;

        const isDeri = this.globals.hammadde === "deri";
        
        // HERKES İÇİN SABİT SCALE: 2
        // Burayı 2.5 veya 3 yaparsan hepsi aynı anda değişir.
        const textureScale = 2; 

        // PATH TANIMLARI
        const pathDeri = { norm: '/static/textures/deri/deri_normal.jpg', rough: '/static/textures/deri/deri_roughness3.jpg' };
        const pathKumas = { norm: '/static/textures/kumas/kumas_normal2.webp', rough: '/static/textures/kumas/kumas_roughness.jpg' };
        const pathKadife = { norm: '/static/textures/kadife/kadife_normal.jpg', rough: '/static/textures/kadife/kadife_roughness.webp' };

        // MATERYAL SEÇİMİ
        let rawCat = this.globals.cinsbutton[0];
        const category = rawCat.charAt(0).toUpperCase() + rawCat.slice(1);
        const mats = this.viewer.model.materials;
        
        let bodyMaterials = [];
        let pillowMaterials = [];

        // Kategoriye göre materyal listeleri...
        if (category.includes("Pro")) {
            bodyMaterials = [mats[7], mats[17], mats[16], mats[9], mats[8],mats[0],mats[13],mats[6],mats[4]];
            pillowMaterials = [mats[14]]; 
        } 
        else if (category.includes("Future")) {
            bodyMaterials = [mats[9], mats[20], mats[29], mats[22], mats[21], mats[17], mats[16], mats[23], mats[19], mats[12],mats[25],mats[26],mats[11],mats[13]];
            pillowMaterials = [mats[9], mats[12]]; 
        } 
        else if (category.includes("Fame")) {
            bodyMaterials = [mats[3], mats[4], mats[5],mats[6], mats[7], mats[9], mats[10], mats[12],mats[27], mats[28], mats[29], mats[30]];
            pillowMaterials = [mats[28]]; 
        } 
        else if (category.includes("Fab")) {
            bodyMaterials = [
                mats[4], mats[5], mats[6],mats[7], mats[12], mats[13], mats[14], mats[15], 
                mats[16], mats[17], mats[18], mats[19], mats[20], mats[21], mats[22], 
                mats[23], mats[29], mats[30], mats[31], mats[32], mats[33], mats[27]
            ];
            pillowMaterials = [mats[6], mats[4]]; 
            
            if (mats[27] && mats[27].pbrMetallicRoughness) {
                mats[27].pbrMetallicRoughness.setBaseColorFactor(isDeri ? [0, 0, 0, 1] : [1, 1, 1, 1]);
            }
        }
        else if (category === "Aksesuar") return; 

        // TEXTURELARI HAZIRLA
        const bodySrc = isDeri ? pathDeri : pathKumas;
        const pillowSrc = isDeri ? pathKadife : pathKumas;

        try {
          

            // Textureları çağır (getCachedTexture artık scale'i zorlayacak)
            const [bodyNorm, bodyRough, pillowNorm, pillowRough] = await Promise.all([
                this.getCachedTexture(bodySrc.norm, textureScale), 
                this.getCachedTexture(bodySrc.rough, textureScale),
                this.getCachedTexture(pillowSrc.norm, textureScale), 
                this.getCachedTexture(pillowSrc.rough, textureScale)
            ]);

            // MATERYALLERE UYGULA
            const assign = (mat, nTex, rTex) => {
                if (!mat) return;
                // Normal Map
                if (mat.normalTexture) mat.normalTexture.setTexture(nTex);
                else if (mat['normalTexture']) mat['normalTexture'].setTexture(nTex);

                // Roughness Map
                if (mat.pbrMetallicRoughness.metallicRoughnessTexture) {
                    mat.pbrMetallicRoughness.metallicRoughnessTexture.setTexture(rTex);
                }
            };

            for (const mat of bodyMaterials) { assign(mat, bodyNorm, bodyRough); }
            for (const mat of pillowMaterials) { assign(mat, pillowNorm, pillowRough); }
      

        } catch (e) {
            console.warn("Texture Apply Error:", e);
        }
    }

   // HawkMaterialManager.js -> getCachedTexture (FIXED: UPDATE SAMPLER ON CACHE HIT)

    // HawkMaterialManager.js -> getCachedTexture (UPDATED WITH GPU FORCE UPDATE)

    async getCachedTexture(url, scale = 2) {
        // Cache key based on URL only (since we dynamically update scale)
        const key = url;
        let texture;

        if (this.textureCache[key]) {
            // 1. Existing texture from cache
            texture = this.textureCache[key];
        } else {
            // 2. New texture download
            texture = await this.viewer.createTexture(url);
            this.textureCache[key] = texture;
        }

        // --- CRITICAL UPDATE BLOCK ---
        if (texture && texture.sampler) {
            
            // 1. Force Repeat Mode (Required for scaling)
            await texture.sampler.setWrapS(10497); // GL_REPEAT
            await texture.sampler.setWrapT(10497); // GL_REPEAT
            
            // 2. Apply Scale
            await texture.sampler.setScale({ u: scale, v: scale });

            // 3. LOW-LEVEL THREE.JS FORCE UPDATE (The missing piece)
            // Access the underlying Three.js texture object if possible to force update
            if (texture.source && texture.source.update) {
                 texture.source.update(); 
            }
            
            // If the viewer exposes the Three.js texture object directly:
            if (texture.needsUpdate !== undefined) {
                texture.needsUpdate = true;
            }
        }

        return texture;
    }
// HawkMaterialManager.js -> Sınıfın içine ekle

    forceFixScales(targetScale = 2) {
        if (!this.viewer || !this.viewer.model) return;

        // console.log(`🔧 Force Fix: Tüm dokular ${targetScale}x olarak zorlanıyor...`);

        this.viewer.model.materials.forEach(mat => {
            // 1. Normal Map
            if (mat.normalTexture && mat.normalTexture.texture && mat.normalTexture.texture.sampler) {
                mat.normalTexture.texture.sampler.setScale({ u: targetScale, v: targetScale });
            }

            // 2. Roughness Map
            if (mat.pbrMetallicRoughness && 
                mat.pbrMetallicRoughness.metallicRoughnessTexture && 
                mat.pbrMetallicRoughness.metallicRoughnessTexture.texture &&
                mat.pbrMetallicRoughness.metallicRoughnessTexture.texture.sampler) {
                
                mat.pbrMetallicRoughness.metallicRoughnessTexture.texture.sampler.setScale({ u: targetScale, v: targetScale });
            }
        });
    }
    async applyNicknameTexture(textureUrl) {
        if(!this.viewer || !this.viewer.model) return;

        let rawCat = this.globals.cinsbutton[0];
        const category = rawCat.charAt(0).toUpperCase() + rawCat.slice(1);
        const productTitle = (this.globals.tasarimismiKontrol && this.globals.tasarimismiKontrol[0]) 
                             ? this.globals.tasarimismiKontrol[0] 
                             : "";

        const mats = this.viewer.model.materials;
        const map = this.getMaterialMap(category, mats, productTitle);

        // 1. Haritadan Nickname Materyalini Al
        let targetMat = map["Nickname"];

        // 2. Haritada Yoksa Manuel Yedek (Safety Fallback)
        if (!targetMat) {
            if(category.includes("Pro")) targetMat = map["PRO BAS YASTIK LOGO"];
            else if(category.includes("Fab")) targetMat = mats[5]; // Fab yedeği
            else if(category.includes("Fame")) targetMat = map["FAME nickname"];
            else targetMat = map["FUTURE yastiklogo"];
        }

        if(targetMat) {
            await this.applyTexture(targetMat, textureUrl);
            // Cache güncelle ki "X" butonuna basınca geri dönsün
            //this.updatePatternCache("Yastık Logo", targetMat); 
        } else {
            console.warn("⚠️ Nickname materyali bulunamadı.");
        }
    }

    // HawkMaterialManager.js -> getMaterialMap GÜNCELLEMESİ

    // HawkMaterialManager.js -> getMaterialMap

    getMaterialMap(category, materials, productTitle = "") {
        if (!materials) return {};
        
        const pName = productTitle.toLowerCase().trim();

        switch (category) {
            case 'Aksesuar':
                let aksesuarMap = {};

                // --- 1. BEL YASTIKLARI ---
                if (pName.includes("bel")) {
                    if (pName.includes("fab")) {
                        // Fab Bel Yastığı
                        aksesuarMap["aksesuar bel yastık logo"] = materials[3];
                        aksesuarMap["aksesuar bel yastık"] = materials[0];
                        aksesuarMap["Bel Logo"] = materials[3];
                        aksesuarMap["Nickname"] = materials[3]; 
                    } else {
                        // Future Bel Yastığı
                        aksesuarMap["aksesuar bel yastık logo"] = materials[0];
                        aksesuarMap["aksesuar bel yastık"] = materials[1];
                        aksesuarMap["Bel Logo"] = materials[0];
                        aksesuarMap["Nickname"] = materials[0];
                    }
                }
                
                // --- 2. BAŞ (ÜST) YASTIKLARI ---
                else if (pName.includes("baş") || pName.includes("bas") || pName.includes("üst") || pName.includes("ust")) {
                    aksesuarMap["aksesuar ustyastik logo"] = materials[5];
                    aksesuarMap["aksesuar ustyastik"] = materials[0];
                    aksesuarMap["Yastık Logo"] = materials[5];
                    aksesuarMap["Nickname"] = materials[5]; 
                }
                
                // --- 3. MOUSE PAD ---
                else if (pName.includes("mouse")) {
                    aksesuarMap["aksesuar mouse pad"] = materials[0];
                }
                
                // --- 4. T-SHIRT ---
                else if (pName.includes("shirt")) {
                    aksesuarMap["aksesuar tshirt"] = materials[0];
                }

                return aksesuarMap;

            case 'Future':
                return {
                    "FUTURE alt-yastik": materials[9], "FUTURE arkalogo": materials[25], "FUTURE bellogo": materials[11], 
                    "FUTURE future-2023": materials[28], "FUTURE kenar": materials[20], "FUTURE oturak-Future-logo": materials[33], 
                    "FUTURE ustlogo": materials[26], "FUTURE arkayastik": materials[24], "FUTURE yastiklogo": materials[13], 
                    "FUTURE alt": materials[29], "FUTURE alt-sag": materials[22], "FUTURE alt-sol": materials[21], 
                    "FUTURE arka": materials[17], "FUTURE on-": materials[16], "FUTURE orta": materials[23], 
                    "FUTURE tepe": materials[19], "FUTURE ust-yastik": materials[12],
                    // Ekstra
                    "Nickname": materials[13]
                };
            case 'Fab':
                return {
                    "FAB alt-ana": materials[29], "FAB altsag": materials[31], "FAB altsag1": materials[30], "FAB altsol": materials[33], 
                    "FAB altsol1": materials[32], "FAB alt-yastik": materials[6], "FAB arka": materials[17], "FAB bel-logo": materials[7], 
                    "FAB fab-koltuk-logo": materials[13], "FAB ön-logo": materials[15], "FAB ustalt": materials[14], "FAB ustarka": materials[16], 
                    "FAB ustsag1": materials[21], "FAB ustsag2": materials[20], "FAB ustsagarka": materials[22], "FAB ustsol1": materials[18], 
                    "FAB ustsol2": materials[19], "FAB ustsolarka": materials[23], "FAB ustust": materials[12], "FAB ustyastik": materials[4],
                    // FAB NICKNAME İNDEKSİ (5)
                    "Yastık Logo": materials[5],
                    "Nickname": materials[5]
                };
            case 'Fame':
                return {
                    "FAME alt": materials[12], "FAME alt-kanat": materials[10], "FAME arka-logo": materials[4], "FAME hawk-logo": materials[5], 
                    "FAME on-logo": materials[6], "FAME ust": materials[3], "FAME ust-kanat": materials[9], "FAME yastik": materials[28], 
                    "FAME fameimza": materials[7], "FAME nickname": materials[27], "FAME dikis": materials[11], "FAME bel-logo": materials[29], 
                    "FAME hawk-kanat": materials[6], "FAME famegold": materials[4], "FAME bas-yastik-logo": materials[27],
                    // Ekstra
                    "Nickname": materials[27]
                };
            case 'Pro':
                return {
                    "PRO ALT": materials[7], "PRO ALT-KANAT": materials[17], "PRO UST-KANAT": materials[16], "PRO UST": materials[9], 
                    "PRO YASTIK": materials[14], "PRO ON-LOGO": materials[4], "PRO ARKA-LOGO": materials[6], "PRO HAWK-LOGO": materials[5], 
                    "PRO BAS YASTIK LOGO": materials[13], "PRO DİKİS": materials[15], "PRO 2025": materials[10], "PRO ALT YAN İMZA": materials[2], 
                    "PRO BEL LOGO": materials[0], "PRO BEL IMZA": materials[1], "PRO KENAR": materials[8], "AURA_MAT": materials[20],
                    // Ekstra
                    "Nickname": materials[13]
                };
            default: return {};
        }
    }

    // HawkMaterialManager.js -> processFeature GÜNCELLEMESİ

    // Not: Parametre listesine 'productTitle' eklendi (en sonda)
    async processFeature(category, feature, materialMap, itemID, patternID, patternTitle, productTitle = "") {
        
        const typeName = feature.TypeName;
        const filePath = feature.FilePath;

        // Debug (İstersen kaldırabilirsin)
        // console.log(`🔍 processFeature: ${typeName}, Ürün: ${productTitle}`);

        // Eğer materialMap boşsa veya eksikse, productTitle ile yeniden oluşturmayı dene
        if (!materialMap || Object.keys(materialMap).length === 0) {
            const mats = this.viewer.model ? this.viewer.model.materials : [];
            materialMap = this.getMaterialMap(category, mats, productTitle);
        }

        const material = materialMap[typeName];

        if (typeName === "icon") return;
        
        // Materyal bulunamadıysa ve logic-only değilse dur
        if (!material && !this.isLogicOnlyFeature(typeName)) {
            // Aksesuar için özel bir şans daha verelim (Map boş gelmiş olabilir)
            if (category === "Aksesuar") {
                // handleAksesuarLogic içinde materyali tekrar bulabiliriz belki?
                // Ama en sağlıklısı yukarıda map'i yeniden oluşturmaktı.
                // Eğer hala yoksa log basıp çıkalım.
                return;
            }
            return;
        }

        if (category === 'Pro') await this.handleProLogic(feature, material, filePath, materialMap, itemID, patternTitle);
        else if (category === 'Fame') await this.handleFameLogic(feature, material, filePath, materialMap, patternTitle);
        else if (category === 'Fab') await this.handleFabLogic(feature, material, filePath, materialMap, patternTitle);
        else if (category === 'Aksesuar') await this.handleAksesuarLogic(feature, material, filePath, materialMap, patternTitle);
        else await this.handleFutureLogic(feature, material, filePath, materialMap, patternTitle);
    }

    isLogicOnlyFeature(typeName) {
        const logicFeatures = ["FUTURE ustlogo", "FUTURE arkalogo", "FUTURE bellogo", "PRO ON-LOGO", "FAME hawk-kanat"];
        return logicFeatures.some(f => typeName.includes(f));
    }
// -------------------------------------------------------
    // GİZLİ CACHE GÜNCELLEME (GÖRÜNTÜYÜ BOZMADAN YEDEK AL)
    // -------------------------------------------------------
    async forceUpdateCache(type, url) {
        // console.log(`🕵️ Gizli Cache Güncellemesi: ${type} -> ${url}`);
        
        try {
            // Dokuyu indir (Ekrana basma, sadece hafızaya al)
            // Fame/Future fark etmeksizin standart scale (1) ile alıyoruz, 
            // çünkü revertTexture zaten scale ayarlarını yapıyor olabilir veya standarttır.
            const texture = await this.getCachedTexture(url, 1); 
            
            // Eğer o tip için bir kayıt varsa, texture'ını güncelle
            if (this.originalTextures && this.originalTextures[type]) {
                this.originalTextures[type].texture = texture;
                // console.log(`   ✅ Cache [${type}] yeni desene güncellendi.`);
            } else {
                // Kayıt yoksa oluştur (Nadir durum)
                // Materyal referansını map'ten bulmamız gerekebilir ama şimdilik pas geçiyoruz
                // çünkü captureInitialState zaten iskeleti oluşturdu.
            }
        } catch (e) {
            console.warn(`   ⚠️ Gizli Cache Hatası:`, e);
        }
    }
    // ... (handleFutureLogic, handleFabLogic vb. fonksiyonları ESKİ KODUNDAN AYNEN KOPYALA) ...
    // Bu logic fonksiyonları değişmedi, sadece confirmSelection değişti.
    // -------------------------------------------------------
    // 1. FUTURE LOGIC (GÜNCELLENDİ)
    // -------------------------------------------------------
    // HawkMaterialManager.js -> handleFutureLogic (ARKA YASTIK ÖZELLEŞTİRME DESTEĞİ)

    async handleFutureLogic(feature, material, filePath, map, patternTitle) {
        // ... (Değişkenler ve Standart Parçalar AYNI) ...
        const typeName = feature.TypeName;
        
        // Standart atamalar
        if (typeName === "FUTURE ustlogo") { this.globals.onid = feature.FeatureID; if (!this.globals.onlogoyuklendi) window.updateOrderJson(feature.FeatureID, "Features.Patterns.Front"); }
        if (typeName === "FUTURE alt-yastik") this.globals.belcacheLink2 = filePath;
        if (typeName === "FUTURE arkalogo") { this.globals.arkaid = feature.FeatureID; if (!this.globals.arkalogoyuklendi) window.updateOrderJson(feature.FeatureID, "Features.Patterns.Back"); }
        if (typeName === "FUTURE bellogo") { this.globals.belid = feature.FeatureID; if (!this.globals.bellogoyuklendi) window.updateOrderJson(feature.FeatureID, "Features.Patterns.Waist"); }
        if (typeName === "FUTURE kenar") { this.globals.kenarid = feature.FeatureID; window.updateOrderJson(feature.FeatureID, "Features.Patterns.Side"); }

        // --- ARKA YASTIK (ÖZEL DURUM) ---
        // Eğer veritabanından gelen özellik "FUTURE arkayastik" ise, bunu direkt uygula ve çık.
        // Bu sayede aşağıda "Ön yastık ile aynısını yap" mantığı ezilmiş olur.
        if (typeName === "FUTURE arkayastik") {
            if (map["FUTURE arkayastik"]) {
                // console.log("🎯 Özel Arka Yastık Deseni Bulundu:", filePath);
                await this.applyTexture(map["FUTURE arkayastik"], filePath);
            }
            return; // İşlem tamam, diğer bloklara girmesin.
        }

        // --- YASTIK LOGO (ÖN YASTIK) ---
        if (material === map["FUTURE yastiklogo"] || material === map["aksesuar ustyastik logo"]) {
             this.globals.yastikid = feature.FeatureID;
             
             // --- KRİTİK GÜNCELLEME BURADA ---
             // Arka yastığa ne uygulanacak?
             // 1. Önce global features listesinde "FUTURE arkayastik" var mı diye bak.
             // (window.currentPatternFeatures HawkProductLogic'te set ediliyor)
             const hasCustomBackPillow = window.currentPatternFeatures && window.currentPatternFeatures.some(f => f.TypeName === "FUTURE arkayastik");

             // 2. Eğer özel arka yastık YOKSA, ön yastığın aynısını arkaya da uygula (Eski Sistem)
             if (!hasCustomBackPillow && map["FUTURE arkayastik"]) {
                 await this.applyTexture(map["FUTURE arkayastik"], filePath);
             }
             // Varsa hiçbir şey yapma, çünkü yukarıdaki `if (typeName === "FUTURE arkayastik")` bloğu onu zaten halledecek.
             // --------------------------------

             if (this.globals.nicknameyuklendi) { 
                 // Nickname var, dokunma AMA CACHE GÜNCELLE
                 this.forceUpdateCache("Nickname", filePath);
                 this.forceUpdateCache("Yastık Logo", filePath);
             } 
             else if (this.globals.yastiklogoyuklendi) { 
                 // Logo var, dokunma AMA CACHE GÜNCELLE
                 if (typeof guncelleCustomFiyat === 'function') guncelleCustomFiyat("Üst Yastık Logo"); 
                 this.forceUpdateCache("Yastık Logo", filePath);
                 this.forceUpdateCache("Nickname", filePath);
             } 
             else {
                 // Desen Modu (Normal)
                 window.updateOrderJson("", "Features.Nickname.Text");
                 await this.applyTexture(material, filePath);
                 this.updatePatternCache("Yastık Logo", material); 
                 this.updatePatternCache("Nickname", material);
             }
             this.globals.ustyastikcache = [filePath];
        }
        
        // --- ARKA LOGO ---
        else if (material === map["FUTURE arkalogo"]) {
             if (this.globals.arkalogoyuklendi) { 
                 if (typeof guncelleCustomFiyat === 'function') guncelleCustomFiyat("Arka Logo"); 
                 // --- EKLENEN: GİZLİ GÜNCELLEME ---
                 this.forceUpdateCache("Arka Logo", filePath);
             } else { 
                 await this.applyTexture(material, filePath); 
                 this.updatePatternCache("Arka Logo", material); 
             }
             this.globals.arkacache = [filePath];
        }
        
        // --- ÖN LOGO ---
        else if (material === map["FUTURE ustlogo"]) {
             if (this.globals.onlogoyuklendi) { 
                 if (typeof guncelleCustomFiyat === 'function') guncelleCustomFiyat("Ön Logo"); 
                 // --- EKLENEN: GİZLİ GÜNCELLEME ---
                 this.forceUpdateCache("Ön Logo", filePath);
             } else { 
                 await this.applyTexture(material, filePath); 
                 this.updatePatternCache("Ön Logo", material); 
             }
             this.globals.oncache = [filePath];
        }

        // --- BEL LOGO ---
        else if (material === map["FUTURE bellogo"] || typeName === "FUTURE bellogo") {
            this.globals.belid = feature.FeatureID;

            if (this.globals.bellogoyuklendi) {
                // Custom Logo Yüklü
                if (typeof guncelleCustomFiyat === 'function') guncelleCustomFiyat("Bel Logo");
                
                // 1. Logoyu Bas
                const userLogo = (this.globals.resultbellogo && this.globals.resultbellogo[0]) ? this.globals.resultbellogo[0] : filePath;
                await this.applyTexture(material, userLogo);
                
                // 2. Arka Planı GÜNCEL RENKLE Temizle
                if (this.globals.belCleanLink && map["FUTURE alt-yastik"]) {
                    // console.log(`   🎨 Bel Arka Planı Güncelleniyor: ${this.globals.belCleanLink}`);
                    await this.applyTexture(map["FUTURE alt-yastik"], this.globals.belCleanLink);
                }

                // 3. Cache Güncelle (Remove için)
                this.forceUpdateCache("Bel Logo", filePath);

            } else {
                // Desen Modu
                await this.applyTexture(material, filePath);
                this.updatePatternCache("Bel Logo", material);
                if(map["FUTURE alt-yastik"]) this.updatePatternCache("FUTURE alt-yastik", map["FUTURE alt-yastik"]);
            }
            
            this.globals.belcache = [filePath];
            if (!this.globals.bellogoyuklendi) window.updateOrderJson(feature.FeatureID, "Features.Patterns.Waist");
        }
        
        else if (material) {
            await this.applyTexture(material, filePath);
        }
    }

    // -------------------------------------------------------
    // 2. FAB LOGIC (GÜNCELLENDİ)
    // -------------------------------------------------------
   // -------------------------------------------------------
    // FAB LOGIC (YASTIK SENKRONİZASYONU + FULL CACHE)
    // -------------------------------------------------------
    async handleFabLogic(feature, material, filePath, map, patternTitle) {
        const typeName = feature.TypeName;

        // --- STANDART PARÇALAR ---
        if (typeName === "FAB ön-logo") { 
            this.globals.onid = feature.FeatureID; 
            if (!this.globals.onlogoyuklendi) window.updateOrderJson(feature.FeatureID, "Features.Patterns.Front"); 
        }
        if (typeName === "FAB arka") { 
            this.globals.arkaid = feature.FeatureID; 
            if (!this.globals.arkalogoyuklendi) window.updateOrderJson(feature.FeatureID, "Features.Patterns.Back"); 
        }
        if (typeName === "FAB bel-logo") { 
            this.globals.belid = feature.FeatureID; 
            if (!this.globals.bellogoyuklendi) window.updateOrderJson(feature.FeatureID, "Features.Patterns.Waist"); 
        }
        if (typeName === "FAB altsag1") { 
            this.globals.kenarid = feature.FeatureID; 
            window.updateOrderJson(feature.FeatureID, "Features.Patterns.Side"); 
        }

        // --- YASTIK / NICKNAME (INDEX 13 & 5) ---
        if (material === map["FAB fab-koltuk-logo"]) { // Index 13
            console.log(this.globals.yastiklogoyuklendi)
            console.log(this.globals.nicknameyuklendi)
            // DURUM 1: Custom Logo/Nickname Yüklü -> DOKUNMA
            if (this.globals.yastiklogoyuklendi || this.globals.nicknameyuklendi) {
                 // Custom yüklü, desen değişimini yastığa yansıtma (veya sadece arkaya yansıt)
                 // Cache güncelle:
                 this.forceUpdateCache("Yastık Logo", filePath);
                 this.forceUpdateCache("Nickname", filePath);
            } 
            
            // DURUM 2: Desen Seçimi -> UYGULA
            else {
                this.globals.yastikid = feature.FeatureID;
                
                // "Boğa" deseni istisnası (Sarı logo)
                console.log(map)
                // "Boğa" deseni istisnası (Sarı logo)
                // material (13. index - Arka) -> API'den gelen (filePath)
                // map["Nickname"] (5. index - Ön) -> Sarı Logo (bogalogo)
                
                if (patternTitle && patternTitle.includes("Boğa")) {
                    const bogalogo = "/static/butonlar/ekstra/fabsarilogo.png";
                    
                    // 1. API'den gelen deseni 13'e (Arka - material) uygula
                    await this.applyTexture(material, bogalogo); 

                    // 2. Sarı logoyu 5'e (Ön - Nickname) uygula
                    if (map["Nickname"]) {
                        await this.applyTexture(map["Nickname"], filePath); 
                    }
                    
                    // Cache
                    this.updatePatternCache("Yastık Logo", material); 
                    if (map["Nickname"]) this.updatePatternCache("Nickname", map["Nickname"]);
                }
                else {
                    // Standart Desen
                    await this.applyTexture(material, filePath); // 13
                    if (map["Nickname"]) await this.applyTexture(map["Nickname"], filePath); // 5
                    
                    // Cache
                    this.updatePatternCache("Yastık Logo", map["Nickname"]); // 5'i kaydet (Ön yüz)
                    this.updatePatternCache("Nickname", map["Nickname"]);
                }

                window.updateOrderJson("", "Features.Nickname.Text");
            }
            this.globals.ustyastikcache = [filePath];
        }

        // --- ARKA LOGO ---
        else if (material === map["FAB arka"]) {
            if (this.globals.arkalogoyuklendi) { 
                if (typeof guncelleCustomFiyat === 'function') guncelleCustomFiyat("Arka Logo"); 
                this.forceUpdateCache("Arka Logo", filePath);
            } else { 
                await this.applyTexture(material, filePath); 
                this.updatePatternCache("Arka Logo", material); 
            }
            this.globals.arkacache = [filePath];
        }

        // --- BEL LOGO ---
        else if (material === map["FAB bel-logo"]) {
            if (this.globals.bellogoyuklendi) { 
                if (typeof guncelleCustomFiyat === 'function') guncelleCustomFiyat("Bel Logo"); 
                this.forceUpdateCache("Bel Logo", filePath);
            } else { 
                await this.applyTexture(material, filePath); 
                this.updatePatternCache("Bel Logo", material); 
            }
            this.globals.belcache = [filePath];
        }

        // --- ÖN LOGO ---
        else if (material === map["FAB ön-logo"]) {
            if (this.globals.onlogoyuklendi) { 
                if (typeof guncelleCustomFiyat === 'function') guncelleCustomFiyat("Ön Logo"); 
                this.forceUpdateCache("Ön Logo", filePath);
            } else { 
                await this.applyTexture(material, filePath); 
                this.updatePatternCache("Ön Logo", material); 
            }
            this.globals.oncache = [filePath];
        }

        else if (material) {
            await this.applyTexture(material, filePath);
        }
    }
    // -------------------------------------------------------
    // 3. FAME LOGIC (GÜNCELLENDİ)
    // -------------------------------------------------------
    // -------------------------------------------------------
    // FAME LOGIC (FULL CACHE DESTEKLİ)
    // -------------------------------------------------------
    // -------------------------------------------------------
    // FAME LOGIC (DATA FIX: on-logo & arka-logo)
    // -------------------------------------------------------
    async handleFameLogic(feature, material, filePath, map, patternTitle) {
        const typeName = feature.TypeName;

        // --- ID GÜNCELLEME (VERİTABANI EŞLEŞTİRME) ---
        // Senin verine göre: 'FAME on-logo' ve 'FAME arka-logo'
        
        // 1. ÖN LOGO (Front)
        if (typeName === "FAME on-logo" || typeName === "FAME hawk-kanat") { 
            this.globals.onid = feature.FeatureID; 
            if (!this.globals.onlogoyuklendi) window.updateOrderJson(feature.FeatureID, "Features.Patterns.Front"); 
        }
        
        // 2. ARKA LOGO (Back)
        if (typeName === "FAME arka-logo" || typeName === "FAME famegold") { 
            this.globals.arkaid = feature.FeatureID; 
            if (!this.globals.arkalogoyuklendi) window.updateOrderJson(feature.FeatureID, "Features.Patterns.Back"); 
        }
        
        // 3. BEL LOGO (Waist)
        if (typeName === "FAME bel-logo") { 
            this.globals.belid = feature.FeatureID; 
            if (!this.globals.bellogoyuklendi) window.updateOrderJson(feature.FeatureID, "Features.Patterns.Waist"); 
        }
        
        // 4. YAN/KANAT (Side)
        if (typeName === "FAME ust-kanat" || typeName === "FAME hawk-logo") { 
            this.globals.kenarid = feature.FeatureID; 
            window.updateOrderJson(feature.FeatureID, "Features.Patterns.Side"); 
        }

        // --- TEXTURE UYGULAMA & CACHE ---

        // A) YASTIK / NICKNAME
        if (material === map["FAME nickname"]) {
            this.globals.yastikid = feature.FeatureID;
            if (this.globals.nicknameyuklendi || this.globals.yastiklogoyuklendi) { 
                if (typeof guncelleCustomFiyat === 'function') guncelleCustomFiyat("Üst Yastık Logo"); 
                this.forceUpdateCache("Yastık Logo", filePath);
                this.forceUpdateCache("Nickname", filePath);
            }
            else {
                window.updateOrderJson("", "Features.Nickname.Text");
                await this.applyTexture(material, filePath);
                this.updatePatternCache("Yastık Logo", material); 
                this.updatePatternCache("Nickname", material);
            }
            this.globals.ustyastikcache = [filePath];
        }

        // B) ARKA LOGO (Map ismi 'FAME arka-logo' veya 'FAME famegold' olabilir)
        else if (material === map["FAME arka-logo"] || material === map["FAME famegold"]) {
            if (this.globals.arkalogoyuklendi) { 
                if (typeof guncelleCustomFiyat === 'function') guncelleCustomFiyat("Arka Logo"); 
                this.forceUpdateCache("Arka Logo", filePath);
            } else { 
                await this.applyTexture(material, filePath); 
                this.updatePatternCache("Arka Logo", material); 
            }
            this.globals.arkacache = [filePath];
        }

        // C) BEL LOGO
        else if (material === map["FAME bel-logo"]) {
            if (this.globals.bellogoyuklendi) { 
                if (typeof guncelleCustomFiyat === 'function') guncelleCustomFiyat("Bel Logo"); 
                this.forceUpdateCache("Bel Logo", filePath);
            } else { 
                await this.applyTexture(material, filePath); 
                this.updatePatternCache("Bel Logo", material); 
            }
            this.globals.belcache = [filePath];
        }

        // D) ÖN LOGO (Map ismi 'FAME on-logo')
        else if (material === map["FAME on-logo"]) {
            if (this.globals.onlogoyuklendi) { 
                if (typeof guncelleCustomFiyat === 'function') guncelleCustomFiyat("Ön Logo"); 
                this.forceUpdateCache("Ön Logo", filePath);
            } else { 
                await this.applyTexture(material, filePath); 
                this.updatePatternCache("Ön Logo", material); 
            }
            this.globals.oncache = [filePath];
        }

        else if (material) {
            await this.applyTexture(material, filePath);
        }
    }
    // -------------------------------------------------------
    // 4. PRO LOGIC (GÜNCELLENDİ)
    // -------------------------------------------------------
    // HawkMaterialManager.js -> handleProLogic (PRO LOGO FIX)

    async handleProLogic(feature, material, filePath, map, itemID, patternTitle) {
        const typeName = feature.TypeName;
        if (typeName === "PRO ON-LOGO") { this.globals.onid = feature.FeatureID; if (!this.globals.onlogoyuklendi) window.updateOrderJson(feature.FeatureID, "Features.Patterns.Front"); }
        if (typeName === "PRO ARKA-LOGO") { this.globals.arkaid = feature.FeatureID; if (!this.globals.arkalogoyuklendi) window.updateOrderJson(feature.FeatureID, "Features.Patterns.Back"); }
        if (typeName === "PRO UST-KANAT") { this.globals.kenarid = feature.FeatureID; window.updateOrderJson(feature.FeatureID, "Features.Patterns.Side"); }

        // --- YASTIK / NICK ---
        if (material === map["PRO BAS YASTIK LOGO"]) {
             this.globals.yastikid = feature.FeatureID;
             if (this.globals.nicknameyuklendi || this.globals.yastiklogoyuklendi) { 
                  if (typeof guncelleCustomFiyat === 'function') guncelleCustomFiyat("Üst Yastık Logo");
                  // --- GİZLİ GÜNCELLEME ---
                  this.forceUpdateCache("Yastık Logo", filePath);
                  this.forceUpdateCache("Nickname", filePath);
             } else {
                 window.updateOrderJson("", "Features.Nickname.Text");
                 await this.applyTexture(material, filePath);
                 this.updatePatternCache("Yastık Logo", material);
             }
             this.globals.ustyastikcache = [filePath];
        }
        
        // --- ARKA LOGO ---
        else if (material === map["PRO ARKA-LOGO"]) {
             if (this.globals.arkalogoyuklendi) { 
                 if (typeof guncelleCustomFiyat === 'function') guncelleCustomFiyat("Arka Logo"); 
                 this.forceUpdateCache("Arka Logo", filePath); // <--- EKLE
             } else { 
                 await this.applyTexture(material, filePath); 
                 this.updatePatternCache("Arka Logo", material); 
             }
             this.globals.arkacache = [filePath];
        }

        // --- ÖN LOGO ---
        else if (material === map["PRO ON-LOGO"]) {
             if (this.globals.onlogoyuklendi) { 
                 if (typeof guncelleCustomFiyat === 'function') guncelleCustomFiyat("Ön Logo"); 
                 this.forceUpdateCache("Ön Logo", filePath); // <--- EKLE
             } else { 
                 await this.applyTexture(material, filePath); 
                 this.updatePatternCache("Ön Logo", material); 
             }
             this.globals.oncache = [filePath];
        }

        // --- BEL LOGO ---
        else if (material === map["PRO BEL LOGO"] || typeName === "PRO BEL LOGO") {
            this.globals.belid = feature.FeatureID;

            if (this.globals.bellogoyuklendi) {
                if (typeof guncelleCustomFiyat === 'function') guncelleCustomFiyat("Bel Logo");
                
                const logoUrl = (this.globals.resultbellogo && this.globals.resultbellogo[0]) ? this.globals.resultbellogo[0] : filePath;
                await this.applyTexture(material, logoUrl);

                if (this.globals.proCleanLink && map["PRO YASTIK"]) await this.applyTexture(map["PRO YASTIK"], this.globals.proCleanLink);
                if (this.globals.probelcacheLink && map["PRO BEL IMZA"]) await this.applyTexture(map["PRO BEL IMZA"], this.globals.probelcacheLink);
                
                // --- KRİTİK: YENİ DESENİ CACHE'LE ---
                this.forceUpdateCache("Bel Logo", filePath);
                
                // Pro'nun arka planlarını da cache'le (Desenli hallerini)
                // Not: Desenli halin linki feature.FilePath içinde olmayabilir, 
                // bu yüzden map'teki mevcut materyalin dokusunu kaydetmek gerekebilir.
                // Ama şimdilik sadece Logoyu kaydediyoruz, arka plan revertTexture'da hallediliyor.

            } else {
                await this.applyTexture(material, filePath);
                this.updatePatternCache("Bel Logo", material);
                if(map["PRO YASTIK"]) this.updatePatternCache("PRO YASTIK", map["PRO YASTIK"]);
                if(map["PRO BEL IMZA"]) this.updatePatternCache("PRO BEL IMZA", map["PRO BEL IMZA"]);
            }
            
            this.globals.belcache = [filePath];
            if (!this.globals.bellogoyuklendi) window.updateOrderJson(feature.FeatureID, "Features.Patterns.Waist");
        }
        
        // ... (Diğerleri aynı) ...
        else if (material === map["PRO BEL IMZA"]) {
             if (!this.globals.bellogoyuklendi) {
                 await this.applyTexture(material, filePath);
                 this.updatePatternCache("PRO BEL IMZA", material);
             }
             this.globals.belcachepro = [filePath];
        }
        
        // Dikiş ve Diğerleri
        else if (material === map["PRO DİKİS"]) {
             const auraMat = map["AURA_MAT"];
             if (itemID === 31) {
                 await this.applyTexture(material, filePath);
                 if (auraMat) this.setMaterialVisibility(auraMat, false);
             } else {
                 await this.applyTexture(material, filePath);
                 if (auraMat) {
                     await this.applyTexture(auraMat, filePath);
                     this.setMaterialVisibility(auraMat, true);
                 }
             }
        }
        else if (material) {
            await this.applyTexture(material, filePath);
        }
    }

    setMaterialVisibility(material, isVisible) {
        if (!material || !material.pbrMetallicRoughness) return;

        // Mevcut rengi al
        const color = material.pbrMetallicRoughness.baseColorFactor;
        
        // Alpha kanalını (4. değer) ayarla: 1 = Görünür, 0 = Görünmez
        const alpha = isVisible ? 1.0 : 0.0;
        
        // Rengi güncelle
        material.pbrMetallicRoughness.setBaseColorFactor([color[0], color[1], color[2], alpha]);
        
        // Alpha modunu güncelle (Görünmezlik için gereklidir)
        if (!isVisible) {
            // Eğer materyalde zaten setAlphaMode yoksa (eski versiyon) hata vermesin diye try-catch
            try { material.setAlphaMode('BLEND'); } catch(e) {}
            try { material.setAlphaCutoff(0.5); } catch(e) {}
        }
    }
    // -------------------------------------------------------
    // 5. AKSESUAR LOGIC (GÜNCELLENDİ - Desen Desteği)
    // -------------------------------------------------------
    // -------------------------------------------------------
    // 5. AKSESUAR LOGIC (DÜZELTİLDİ)
    // -------------------------------------------------------
    // HawkMaterialManager.js -> handleAksesuarLogic GÜNCELLEMESİ

    // -------------------------------------------------------
    // AKSESUAR LOGIC (BEL YASTIĞI TEMİZLEME DESTEKLİ)
    // -------------------------------------------------------
    async handleAksesuarLogic(feature, material, filePath, map, patternTitle) {
        const typeName = feature.TypeName.toLowerCase();
        
        // 1. BAŞ (ÜST) YASTIKLARI
        if (typeName.includes("ustyastik") || typeName.includes("ust-yastik")) {
            if (material) {
                await this.applyTexture(material, filePath);
                
                if (typeName.includes("logo")) {
                    this.globals.yastikid = feature.FeatureID;
                    this.globals.ustyastikcache = [filePath];
                    
                    if(!this.globals.yastiklogoyuklendi && !this.globals.nicknameyuklendi) {
                         window.updateOrderJson("", "Features.Nickname.Text");
                         this.updatePatternCache("Yastık Logo", material);
                         this.updatePatternCache("Nickname", material);
                    } else {
                         // Logo yüklü olsa bile aksesuar modunda desen değişimi anlık olur
                         this.forceUpdateCache("Yastık Logo", filePath);
                         this.forceUpdateCache("Nickname", filePath);
                    }
                } else {
                    this.syncAllParts(feature.FeatureID);
                }
            }
        }

        // 2. BEL YASTIKLARI
        else if (typeName.includes("bel yastık") || typeName.includes("bel-yastik")) {
            if (material) {
                // Desen Uygula
                await this.applyTexture(material, filePath);

                if (typeName.includes("logo")) {
                    if (this.globals.bellogoyuklendi) {
                        if (typeof guncelleCustomFiyat === 'function') guncelleCustomFiyat("Bel Logo");
                        
                        // AKSESUAR İÇİN TEMİZLEME MANTIĞI
                        // Eğer Future Bel Yastığı ise ve Logo Yüklüyse Arka Planı Temizle
                        if (map["aksesuar bel yastık"]) { 
                            // Not: Aksesuarda 'aksesuar bel yastık' hem kumaş hem logoyu tutuyor olabilir.
                            // Eğer Future ise ve Clean Link varsa:
                            if (this.globals.belCleanLink) {
                                console.log(`   🧹 Aksesuar Bel Temizleniyor: ${this.globals.belCleanLink}`);
                                await this.applyTexture(map["aksesuar bel yastık"], this.globals.belCleanLink);
                            }
                        }

                    } else {
                        // Logo yok, desenin kendisi (Baked) kalsın
                        this.updatePatternCache("Bel Logo", material);
                        this.globals.belid = feature.FeatureID;
                        this.globals.belcache = [filePath];
                        
                        // Arka planı da cache'le (Future için)
                        if(map["aksesuar bel yastık"]) {
                            this.updatePatternCache("aksesuar bel yastık", map["aksesuar bel yastık"]);
                        }
                    }
                } else {
                    this.syncAllParts(feature.FeatureID);
                }
            }
        }

        // 3. MOUSE PAD & T-SHIRT (Zaten kaldırıldı ama kod hatası vermesin diye)
        else if (typeName.includes("mouse") || typeName.includes("shirt")) {
            // ...
        }
    }

    // Helper: Tüm parçalara aynı ID'yi ata (Aksesuarlar için)
    syncAllParts(id) {
        if(window.updateOrderJson) {
            window.updateOrderJson(id, "Features.Patterns.Front");
            window.updateOrderJson(id, "Features.Patterns.Back");
            window.updateOrderJson(id, "Features.Patterns.Waist");
            window.updateOrderJson(id, "Features.Patterns.Side");
        }
    }
   // -------------------------------------------------------
    // MATERIAL POPUP (3D MODEL TIKLAMASI İÇİN)
    // -------------------------------------------------------
    triggerMaterialPopup(materialName, category) {
        const popup = document.getElementById("confirmationPopup");
        if (!popup) return;

        const popupText = popup.querySelector(".popup-content p");
        const confirmYes = document.getElementById("confirmYes");
        const confirmNo = document.getElementById("confirmNo");
        const popupContent = popup.querySelector(".popup-content");

        // Temizlik (Eski butonları kaldır)
        const oldBtns = popupContent.querySelectorAll("#addLogo, #addNickname");
        oldBtns.forEach(b => b.remove());
        confirmYes.style.display = "inline-block";

        // Okunabilir İsimler Haritası
        const readableNames = {
            "yastik-logo.001": "Yastık Logosunu", "arkalogo.001": "Arka Logoyu", "bel-logo": "Bel Logosunu", "ustlogo.001": "Ön Logoyu",
            "ust-logo": "Yastık Logosunu", "logo-arkaa": "Arka Logoyu", "on-logo": "Ön Logoyu",
            "nickname": "Yastık Logosunu", "arka-logo": "Arka Logoyu", "onlogo": "Ön Logoyu",
            "yastiklogo.004": "Yastık Logosunu", "arkalogo": "Arka Logoyu"
        };

        const name = readableNames[materialName] || "bu alanı";

        // Yastık/Nickname Ayrımı (Özel Durum)
        const isPillow = ["yastik-logo.001", "ust-logo", "nickname", "yastiklogo.004"].includes(materialName);
        
        if (isPillow) {
            popupText.innerHTML = "Baş yastığına bir logo eklemek veya isim yazdırmak ister misiniz?";
            confirmYes.style.display = "none"; // Standart evet butonunu gizle

            // Logo Butonu Oluştur
            const logoBtn = document.createElement("button");
            logoBtn.id = "addLogo";
            logoBtn.innerHTML = "Logo Ekle";
            logoBtn.className = "comfirmation"; 
            logoBtn.style.marginRight = "10px";
            logoBtn.onclick = () => {
                this.updateActiveOption(5); // Yastık Logo Modu (Index 5)
                popup.style.display = "none";
            };

            // Nickname Butonu Oluştur
            const nickBtn = document.createElement("button");
            nickBtn.id = "addNickname";
            nickBtn.innerHTML = "İsim Yaz";
            nickBtn.className = "comfirmation";
            nickBtn.onclick = () => {
                this.updateActiveOption(4); // Nickname Modu (Index 4)
                popup.style.display = "none";
            };

            popupContent.appendChild(logoBtn);
            popupContent.appendChild(nickBtn);

        } else {
            // Standart Alanlar (Ön, Arka, Bel)
            popupText.innerHTML = `${name} değiştirmek istediğinize emin misiniz?`;
            
            confirmYes.onclick = () => {
                // Hangi butona basılmış gibi yapalım?
                let targetIndex = 0;
                if (name.includes("Ön")) targetIndex = 1;
                else if (name.includes("Arka")) targetIndex = 2;
                else if (name.includes("Bel")) targetIndex = 3;
                
                if (targetIndex > 0) this.updateActiveOption(targetIndex);
                popup.style.display = "none";
            };
        }

        // Popup'ı Göster
        popup.style.display = "flex";

        // Hayır Butonu
        confirmNo.onclick = () => {
            popup.style.display = "none";
        };
    }
    updatePatternCache(type, material) {
        if (!material) return;

        // Eğer bu tip için bir kayıt yoksa oluştur
        if (!this.originalTextures[type]) {
            this.originalTextures[type] = {};
        }

        // Materyal referansını ve üzerindeki mevcut dokuyu kaydet
        this.originalTextures[type].material = material;
        
        if (material.pbrMetallicRoughness.baseColorTexture) {
            this.originalTextures[type].texture = material.pbrMetallicRoughness.baseColorTexture.texture;
        } else {
            this.originalTextures[type].texture = null; // Doku yoksa null kaydet
        }

        // console.log(`🔄 Cache Güncellendi: ${type}`);
    }
}

window.hawkMaterials = new HawkMaterialManager();